import { render } from "./Role.vue?vue&type=template&id=e0b7eea0&ts=true"
import script from "./Role.vue?vue&type=script&lang=ts"
export * from "./Role.vue?vue&type=script&lang=ts"

import "./Role.vue?vue&type=style&index=0&id=e0b7eea0&scope=true&lang=css"

import exportComponent from "D:\\Work\\IMMS\\IMMSV3\\App\\IMMS.MasterClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Role.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e0b7eea0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e0b7eea0', __exports__)) {
    console.log('reload')
    api.reload('e0b7eea0', __exports__)
  }
  
  module.hot.accept("./Role.vue?vue&type=template&id=e0b7eea0&ts=true", () => {
    console.log('re-render')
    api.rerender('e0b7eea0', render)
  })

}


export default __exports__